let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page031_game10/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 379,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Kształty</i> <br/>i wybierz ikonę narzędzia <i>Prostokąt. </bri>',
      },
      audio: {
        src: 'games/page031_game10/audio/z15s31-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 918,
        y: 429,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Wybierz dowolną opcję <i>Konturu</i> prostokąta oraz jego <i>Wypełnienia.</i>',
      },
      audio: {
        src: 'games/page031_game10/audio/z15s31-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1159,
        y: 296,
      },
    },
    {
      id: '3',
      // direction: 'left',
      textObj: {
        text: 'Wybierz kolor konturu <br/>i kolor tła.',
      },
      audio: {
        src: 'games/page031_game10/audio/z15s31-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1372,
        y: 360,
      },
    },
    {
      id: '4',
      direction: 'left',
      textObj: {
        text: 'Rysuj prostokąt, trzymając wciśnięty lewy przycisk myszy.',
      },
      audio: {
        src: 'games/page031_game10/audio/z15s31-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 540,
        y: 660,
      },
    },
  ],
};
export default elements;
